import { isEmpty } from 'lodash';
import React, { lazy, useContext, useEffect } from 'react'
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { TokenServices } from '../controllers/services/auth.services';
import { EmpresasServices } from '../pages/Empresas/controllers/services/empresas.services';
import { Dashboard } from '../pages/Dashboard';
import { Login } from '../pages/Login';
import { LoginPublico } from '../pages/LoginPublico';
import { RestablecerClave } from '../pages/RestablecerClave/RestablecerClave';
import { RootState } from '../store';
import { logOut } from '../store/slices/auth';
import { setTieneEmpresasAutorizadas } from '../store/slices/empresa';
import { isAdministrador } from './helpers';
import { PrivateRoute } from './PrivateRoute';
import { PrivateRouter } from './PrivateRouter';
import { PublicRoute } from './PublicRoute';
// Modulos de administracion

export const AppRouter = () => {

    const { auth } = useSelector((state: RootState) => state.auth)

    const isLogged = !isEmpty(auth)
    const dispatch = useDispatch()

    const [fetchValidateTokenPOST, fetchValidateTokenPOSTData] = TokenServices.POST()
    const [fetchMiAccesoGET, fetchMiAccesoGETData] = EmpresasServices.GET_MI_ACCESO()
    const [cookies, setCookie, removeCookie] = useCookies(['CookieTokenEBCN']);

    const handleClickLogOut = () => {

        removeCookie('CookieTokenEBCN', {
            path: '/',
            domain: process.env.REACT_APP_ENVIRONMENT === 'local' ? '' : process.env.REACT_APP_COOKIE_DOMAIN,
        })
        dispatch(logOut())
        // El permiso no se cachea: se devuelve a `null` (todavía no consultado) para que,
        // si entra otro usuario, ni el menú ni el guard de /empreses decidan con el valor
        // del anterior mientras llega la respuesta nueva.
        dispatch(setTieneEmpresasAutorizadas(null))
    }


    useEffect(() => {
        if (isLogged) {
            fetchValidateTokenPOST({
                params: {
                    token: auth.token
                }
            })
        }
        
    }, [])

    useEffect(() => {

        if (fetchValidateTokenPOSTData.status === 200) {

            if (!fetchValidateTokenPOSTData.data?.data) {
                
                handleClickLogOut()
            }
        }
    }, [fetchValidateTokenPOSTData])

    // El acceso al módulo de empresas se consulta al arrancar y al iniciar sesión. No
    // vale con un `[]`: `AppRouter` no se desmonta al entrar (el login navega en cliente),
    // así que sin mirar el token el enlace de Empresas no reaparecería hasta recargar.
    useEffect(() => {
        if (isLogged) {
            fetchMiAccesoGET()
        }
    }, [isLogged, auth.token])

    useEffect(() => {

        const { status, data, loading } = fetchMiAccesoGETData

        // Mientras no haya terminado no se decide nada (el flag sigue en `null`).
        // Se mira `loading` y no `status`/`error` porque en un fallo de red `useAxios`
        // deja los dos en `undefined` (`err?.response?.status`), y entonces la
        // comprobación nunca daría por resuelta la consulta.
        if (loading !== false) return

        if (status === 200 && data) {

            dispatch(setTieneEmpresasAutorizadas(Boolean(data.tiene_empresas)))
        } else {

            // 4xx/5xx o fallo de red: se da por resuelto sin acceso. Es cerrar por
            // defecto, la misma elección que hace el menú al ocultar el enlace.
            dispatch(setTieneEmpresasAutorizadas(false))
        }
    }, [fetchMiAccesoGETData])


    return (
        <Routes>

            <Route path='login' element={<PublicRoute isAuthenticated={isLogged} />}>

                <Route index element={<Login />} />

            </Route>

            <Route path='iniciar-sessio' element={<LoginPublico />} />

            <Route path='restablecer' element={<RestablecerClave />} />

            <Route path='/*' element={<PrivateRoute isAuthenticated={isLogged} isAllowedRol={true} />}>

                <Route path='*' element={<PrivateRouter />} />

            </Route>

            <Route path='default' element={<Login />} />

            <Route path="*" element={<Navigate to="./" replace />} />

        </Routes>
    )
}